/**
 * Visuals Module - Barrel Export
 * Central export point for all visual components and utilities
 */

// Types — explicit named exports (no wildcard)
export type {
  VisualAidType,
  VisualAid,
  MoneyVisualData,
  MoneyBreakdown,
  ColumnVisualData,
  VerbTableData,
  KofschipMnemonicData,
  SyllableBlocksData,
} from './types'
export { VISUAL_AID_TYPES } from './types'

// Registry — explicit named exports (no wildcard)
export {
  VISUAL_REGISTRY,
  VISUAL_REGISTRY_IMPORT_NAMES,
  getVisualComponent,
} from './registry/visualRegistry'

// Components
export {
  VisualAidFactory,
  shouldShowVisualAid,
  VISUAL_AID_FACTORY_SUPPORTED_TYPES,
  SUPPORTED_VISUAL_AID_TYPES,
} from './components/VisualAidFactory'

// Individual visual components (used directly by renderers)
export { AnalogClock } from './components/AnalogClock'
export { GeometricShape } from './components/GeometricShape'
